const styles = () => ({
    banner: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        padding: '8px 12px',
        backgroundColor: '#f5f5f5',
        borderBottom: '1px solid #ddd',
        boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
        gap: '10px',
        minHeight: '64px',
    },
    closeButton: {
        background: 'none',
        border: 'none',
        fontSize: '18px',
        cursor: 'pointer',
        color: '#888',
        padding: '0 4px',
        lineHeight: 1,
        flexShrink: 0,
    },
    icon: {
        width: '48px',
        height: '48px',
        borderRadius: '10px',
        flexShrink: 0,
    },
    info: {
        flex: 1,
        overflow: 'hidden',
    },
    appName: {
        fontWeight: 600,
        fontSize: '14px',
        color: '#222',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    description: {
        fontSize: '12px',
        color: '#666',
        marginTop: '2px',
    },
    openButton: {
        flexShrink: 0,
        backgroundColor: '#1a73e8',
        color: '#fff',
        border: 'none',
        borderRadius: '16px',
        padding: '6px 16px',
        fontSize: '13px',
        fontWeight: 600,
        cursor: 'pointer',
        textDecoration: 'none',
        display: 'inline-block',
        '&:hover': {
            backgroundColor: '#1558b0',
        },
    },
});

export default styles;
